import StaticPageRedirect from '../component/StaticPageRedirect';
export default function Team() { return <StaticPageRedirect page="team" />; }
